export const ADD_Genre_LOADING = 'ADD_C_LOADING'
export const ADD_Genre_ERROR = 'ADD_C_ERROR'
export const ADD_Genre_SUCCESS = 'ADD_C_SUCCESS'
export const UPDATE_LOADING_Genre = 'UPDATE_LOADING'
export const UPDATE_ERROR_Genre = 'UPDATE_ERROR'
export const UPDATE_SUCCESS_Genre = 'UPDATE_SUCCESS'
export const DELETE_Genre = 'DELETE_COLLECTION'
export const CLEAR_NOTIF_STATE = 'CLEAR_NOTIF_STATE'
